var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyCoinsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15510_27800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9.39144H0.666667C0.298667 9.39144 0 9.09277 0 8.72477V0.724772C0 0.356772 0.298667 0.0581055 0.666667 0.0581055H12.6667C13.0347 0.0581055 13.3333 0.356772 13.3333 0.724772V4.05811H12V1.39144H1.33333V8.0581H5.33333V9.39144Z",
    fill: "#97DD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 10.7248C9.36608 10.7248 7.73141 10.2988 6.66675 9.5835C6.66675 10.0808 6.66675 10.4088 6.66675 10.7248C6.66675 11.8295 8.75608 12.7248 11.3334 12.7248C13.9107 12.7248 16.0001 11.8295 16.0001 10.7248C16.0001 10.4088 16.0001 10.0808 16.0001 9.5835C14.9354 10.2988 13.3007 10.7248 11.3334 10.7248Z",
    fill: "#97DD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 14.0581C9.36608 14.0581 7.73141 13.6321 6.66675 12.9167C6.66675 13.4141 6.66675 13.7421 6.66675 14.0581C6.66675 15.1627 8.75608 16.0581 11.3334 16.0581C13.9107 16.0581 16.0001 15.1627 16.0001 14.0581C16.0001 13.7421 16.0001 13.4141 16.0001 12.9167C14.9354 13.6321 13.3007 14.0581 11.3334 14.0581Z",
    fill: "#97DD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93925 5.83936C6.39659 5.30536 7.09525 4.86936 7.98325 4.56202C7.90259 3.90469 7.34659 3.39136 6.66659 3.39136C5.93125 3.39136 5.33325 3.98936 5.33325 4.72469C5.33325 5.19136 5.57525 5.60136 5.93925 5.83936Z",
    fill: "#97DD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 9.39136C13.9107 9.39136 16.0001 8.49593 16.0001 7.39136C16.0001 6.28679 13.9107 5.39136 11.3334 5.39136C8.75609 5.39136 6.66675 6.28679 6.66675 7.39136C6.66675 8.49593 8.75609 9.39136 11.3334 9.39136Z",
    fill: "#97DD7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15510_27800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0581055)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCoinsIcon);
export default __webpack_public_path__ + "static/media/money-coins-icon.58262b854b8a7ebabff165aad280aded.svg";
export { ForwardRef as ReactComponent };